import { Component, Input, OnChanges } from "@angular/core";
import { TagEnum } from "src/app/core/ctf/enums/tag.enum";

@Component({
    selector: "app-ctf-icon",
    templateUrl: "./ctf-icon.component.html",
    styleUrls: ["./ctf-icon.component.scss"],
})
export class CtfIconComponent implements OnChanges{
    @Input() tags!: TagEnum[] | ["NEXT_ENIGME"];
    @Input() sizeIcon!: number;
    @Input() tooltip: boolean = true;

    pathMapType: { [key: string]: string } = {
        WEB: "assets/html.svg",
        OSINT: "assets/socialFaking.svg",
        SQL: "assets/bdd.svg",
        SOFTWARE: "assets/buffer.svg",
        CYPHER: "assets/cypher.svg",
        IMAGE: "assets/app.svg",
        QUIZZ: "assets/quiz.svg",
        HISTORY: "assets/book.svg",
        CLOUD: "assets/cloud.svg",
        IA : "assets/IA.svg",
        NEXT_ENIGME: "assets/timelapse.svg",
    };
    isChapter = false;
    index = 0;
    tagsWithoutStory! : TagEnum[] | ["NEXT_ENIGME"];


    ngOnChanges() {
        this.tagsWithoutStory = [...this.tags];
        this.isChapter = false;
        if(this.tags.length > 1){
            const historyTag = this.tags.find((x) => x === TagEnum.HISTORY);
            this.index = this.tags.findIndex((x) => x === TagEnum.HISTORY);
            if(historyTag){
                this.isChapter = true;
                this.tagsWithoutStory.splice(this.index);
            }
        }
    }
}
